import { useQuery } from '@tanstack/react-query';
import mpx from '../actions/mpx_data';

export const useSeasonEpisodes = (seasonId?: string) =>
    useQuery({
        queryKey: ['season-episodes', seasonId],
        enabled: Boolean(seasonId),
        queryFn: async () => (await mpx.getEpisodes(seasonId)) ?? [],
        refetchOnWindowFocus: false,
    });
